import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Input extends Component {
  state = {
    value: this.props.value,
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
    });
  }

  handleOnChange = (e) => {
    this.setState({
      value: e.target.value,
    });

    if (this.props.onChange) {
      const { value } = e.target;
      this.props.onChange(value);
    }
  };

  doneTyping = (e) => {
    if (this.props.value === this.state.value) {
      return;
    }

    this.props.doneTyping(e);
  };

  handleOnKeyDown = (e) => {
    if (typeof e.key === 'undefined' || e.key !== 'Enter') {
      return;
    }

    const { target } = e;
    this.doneTyping({ target });
  };

  render() {
    const {
      type,
      id,
      className,
      placeholder,
      maxLength,
      autoComplete,
      name,
      disabled,
    } = this.props;

    const { value } = this.state;

    return (
      <input
        type={type}
        id={id}
        className={className}
        placeholder={placeholder}
        maxLength={maxLength}
        value={value}
        autoComplete={autoComplete}
        onChange={this.handleOnChange}
        onKeyDown={this.handleOnKeyDown}
        onBlur={this.doneTyping}
        name={name}
        disabled={disabled}
      />
    );
  }
}

Input.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  autoComplete: PropTypes.oneOf(['on', 'off']),
  onChange: PropTypes.func,
  doneTyping: PropTypes.func.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};

Input.defaultProps = {
  type: 'text',
  autoComplete: 'on',
  name: '',
  onChange: null,
  value: '',
  maxLength: 200,
  placeholder: '',
  className: '',
  id: '',
  disabled: false,
};

export default Input;
